import ButtonToggleGroup from '@leuven2030/framework/Button/ButtonToggleGroup';
import React, { useContext, useEffect } from 'react';
import { PageContext } from '@leuven2030/framework/Page/Page';
import ButtonToggleProvider, {
  ButtonToggleContext
} from '@leuven2030/framework/Button/ButtonToggleProvider';
import { NewsContext } from '@leuven2030/food/News/NewsProvider';
import { useRouter } from 'next/router';

const NewsFilters = () => {
  const {
    prismic: {
      allUpdate_groups,
      news_page: { show_all_label }
    }
  } = useContext(PageContext);
  const router = useRouter();
  const groups: any[] = allUpdate_groups.edges.map(
    ({
      node: {
        title,
        _meta: { uid }
      }
    }) => {
      return {
        label: title,
        value: uid
      };
    }
  );
  if (!router.isReady) {
    return <></>;
  }
  groups.unshift({ label: show_all_label });
  return (
    <ButtonToggleProvider selected={[router.query.group]}>
      <ButtonToggleGroup items={groups} />
      <NewsFiltersController />
    </ButtonToggleProvider>
  );
};

const NewsFiltersController = () => {
  const { selected } = useContext(ButtonToggleContext);
  const { allResults, setFilteredResults } = useContext(NewsContext);
  const router = useRouter();

  useEffect(() => {
    const { group } = router.query;

    if (!group) {
      setFilteredResults(allResults);
      return;
    }
    const filteredResults = allResults.filter(
      ({
        node: {
          group: {
            _meta: { uid }
          }
        }
      }) => {
        return uid == group;
      }
    );
    setFilteredResults(filteredResults);
  }, [router.query]);

  useEffect(() => {
    if (!selected) {
      return;
    }
    const [selectedItem] = selected;
    let query = '';
    if (selectedItem) {
      query = `?group=${selectedItem}`;
    }

    router.replace(`${router.pathname}${query}`, null, {
      shallow: true
    });
  }, [selected]);
  return <></>;
};

export default NewsFilters;
